var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fetchedHotel && !_vm.loading)?_c('div',[(_vm.hotelBottomNavigationMenu)?_c('app-hotel-bottom-navigation',{attrs:{"navigation-menu":_vm.hotelBottomNavigationMenu}}):_c('app-bottom-navigation')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }